import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { ProfilePatient, HistoryPatientSurgery } from "../";

export const ModalViewPatient = ({ viewProfile, setViewProfile, patient }) => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  const [activeIndex, setActiveIndex] = useState(1);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <Modal
      show={viewProfile}
      onHide={() => setViewProfile(false)}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">Información del paciente</h5>
      </Modal.Header>
      <Modal.Body>
        <ul className="nav nav-pills nav-justified flex-column flex-sm-row rounded shadow overflow-hidden bg-light">
          <li className="nav-item">
            <button
              className={`${
                activeIndex === 1 ? "active" : ""
              } nav-link rounded-0`}
              onClick={() => setActiveIndex(1)}
            >
              <div className="text-center pt-1 pb-1">
                <h5 className="mb-0">Perfil</h5>
              </div>
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`${
                activeIndex === 2 ? "active" : ""
              } nav-link rounded-0`}
              onClick={() => setActiveIndex(2)}
            >
              <div className="text-center pt-1 pb-1">
                <h5 className="mb-0">Historial</h5>
              </div>
            </button>
          </li>
        </ul>

        {patient && (
          <div className="tab-content mt-4" id="pills-tabContent">
            {activeIndex === 1 && <ProfilePatient patient={patient} />}
            {activeIndex === 2 && (
              <HistoryPatientSurgery patientId={patient.id} />
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
